import {
  TicketBatch,
  TicketInBatch,
} from "../components/modal-tickets/types/ticket-batch.type";

export function ticketPaidSalesCount(ticket: TicketInBatch): number {
  return Number(ticket.paid_sales_count ?? ticket.sold_quantity ?? 0);
}

export function ticketHasPaidSales(ticket: TicketInBatch): boolean {
  return ticketPaidSalesCount(ticket) > 0;
}

export function ticketHasIssuedAdmissions(ticket: TicketInBatch): boolean {
  return Number(ticket.total_distributed ?? 0) > 0 || ticketHasPaidSales(ticket);
}

export function batchHasPaidSales(batch: TicketBatch): boolean {
  return !!batch.has_paid_sales || (batch.tickets ?? []).some(ticketHasPaidSales);
}

export function eventHasPaidSales(batches: TicketBatch[]): boolean {
  return (batches ?? []).some(batchHasPaidSales);
}

export function batchHasIssuedAdmissions(batch: TicketBatch): boolean {
  return (batch.tickets ?? []).some(ticketHasIssuedAdmissions);
}

export function canDeletePersistedBatch(batch: TicketBatch): boolean {
  return !batch.id || !batchHasIssuedAdmissions(batch);
}

export function canDeletePersistedTicket(ticket: TicketInBatch): boolean {
  return !ticket.id || !ticketHasIssuedAdmissions(ticket);
}
